import { ref, reactive, nextTick } from 'vue';
import { GET, POST } from '@/packge/http';
import { message } from 'ant-design-vue';
import Icons from '@/assets/images/web';
import Common, { isMobilePlatform } from '@/utils/common';

export let thirdAccountList = reactive({
  list: []
});

const iconObj = {
  wechat: [Icons.wechatActive, Icons.wechatGrey],
  weibo: [Icons.weiboActive, Icons.weibotGrey],
  huawei: [Icons.huawei, Icons.huawei] // 华为图标
};

// 第三方账号类型映射：1微信 2华为微信 3QQ 4微博
const accountTypeMap = {
  wechat: 1,
  huawei: 2,
  qq: 3,
  weibo: 4
};
/** 获取用户绑定信息 */
export function getBingInfo () {
  GET({
    url: '/account/bingInfo',
    params: {}
  }).then(({ data }) => {
    // 过滤微信和华为
    const list = data.isBindVOS && data.isBindVOS.filter(item =>
      item.title === '微信' || item.title === '华为'
    );
    thirdAccountList.list = list.map(item => {
      const key = item.title === '微信' ? 'wechat' : item.title === '华为' ? 'huawei' : 'wechat';
      const isHuawei = item.title === '华为';
      // 华为在web端只显示"已绑定"或"未绑定"，不显示昵称
      let valuePrefix;
      if (isMobilePlatform()) {
        valuePrefix = item.status ? '已绑定' : '未绑定';
      } else {
        // Web端：华为不加冒号，微信加冒号
        valuePrefix = isHuawei
          ? (item.status ? '已绑定' : '未绑定')
          : (item.status ? '已绑定: ' : '未绑定');
      }

      return {
        key: key,
        title: item.title,
        icon: item.status ? iconObj[key][0] : iconObj[key][1],
        valuePrefix: valuePrefix,
        status: item.status,
        nickName: isHuawei && !isMobilePlatform() ? '' : item.nickName, // 华为在web端不显示昵称
        handle: item.status ? '解绑' : '去绑定'
      };
    });
    console.log('thirdAccountList: ', thirdAccountList.list);
  });
}

export let visible = ref(false);
export const safeCheck = ref('safeCheck');
export let currentUnbindItem = ref(null); // 当前要解绑的账号

/** 修改绑定状态 */
export function openModal (item, index) {
  console.log('isMobilePlatform(), item.status === false: ', isMobilePlatform(), item.status === false);
  if (isMobilePlatform() && item.status === false) { return; } // 移动端没有绑定微信操作
  currentUnbindItem.value = item; // 保存当前操作的账号
  safeCheck.value.operateState(item);
}

/** 解除绑定 */
export function unbind () {
  const accountType = accountTypeMap[currentUnbindItem.value.key] || 1;
  POST({
    url: '/account/unbindSso',
    params: { type: accountType }
  }).then(({ data }) => {
    message.success('解绑成功');
    visible.value = false;
    getBingInfo();
  });
}
